<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <div formArrayName="ranges">
    <div
      *ngFor="let range of ranges.controls; let i = index; trackBy: trackByIndex"
      [formGroupName]="i"
      class="row-container pb-3 align-items-start">
      <div class="column-container col-3 pe-3">
        <label [for]="'rangeLabel' + i" class="col-form-label pt-0 indicates-required-field">
          {{ 'Settings::RangeLabel' | abpLocalization }}
        </label>
        <input
          type="text"
          class="form-control form-control-sm"
          [id]="'rangeLabel' + i"
          formControlName="label"
          maxlength="50" />
      </div>

      <div class="column-container col-3 pe-3">
        <label [for]="'rangeMin' + i" class="col-form-label pt-0 indicates-required-field">
          {{ 'Settings::MinDurationSec' | abpLocalization }}
        </label>
        <input
          type="number"
          class="form-control form-control-sm"
          [id]="'rangeMin' + i"
          formControlName="minSecs"
          min="0" />
      </div>

      <div class="column-container col-3 pe-3" *ngIf="!isLastRow(i)">
        <label [for]="'rangeMax' + i" class="col-form-label pt-0 indicates-required-field">
          {{ 'Settings::MaxDurationSec' | abpLocalization }}
        </label>
        <input
          type="number"
          class="form-control form-control-sm"
          [id]="'rangeMax' + i"
          formControlName="maxSecs" />
      </div>

      <div class="column-container col-3 pe-3" *ngIf="isLastRow(i)">
        <div class="d-flex justify-content-between align-items-center">
          <label [for]="'rangeMax' + i" class="col-form-label pt-0 indicates-required-field">
            {{ 'Settings::MaxDurationSec' | abpLocalization }}
          </label>
          <mat-slide-toggle
            labelPosition="before"
            [checked]="isOpenEnded(i)"
            (change)="onOpenEndedToggle(i, $event)">
            {{ 'Settings::OpenEnded' | abpLocalization }}
          </mat-slide-toggle>
        </div>
        <input
          *ngIf="!isOpenEnded(i)"
          type="number"
          class="form-control form-control-sm"
          [id]="'rangeMax' + i"
          formControlName="maxSecs" />
        <input
          *ngIf="isOpenEnded(i)"
          type="text"
          class="form-control form-control-sm"
          disabled
          [value]="'∞ ' + ('Settings::NoLimit' | abpLocalization)" />
      </div>

      <div class="column-container col-1 align-items-start justify-content-start">
        <label class="col-form-label pt-0 invisible">&nbsp;</label>
        <button
          class="btn btn-sm ca-btn ca-btn-neutral-command"
          *ngIf="canRemoveRange"
          (click)="removeRange(i)"
          ngbTooltip="{{ '::Delete' | abpLocalization }}"
          type="button">
          <ca-delete-icon></ca-delete-icon>
        </button>
      </div>
    </div>
  </div>

  <button
    type="button"
    class="w-100 btn ca-btn ca-btn-neutral opaque-on-hover"
    [disabled]="!canAddRange"
    (click)="addRange()">
    <i class="fa-duotone fa-plus"></i>
    <span>{{ 'Settings::AddRange' | abpLocalization }}</span>
  </button>

  <button type="submit" class="btn btn-primary mt-3" [disabled]="form.invalid || hasOverlapError">
    <i class="me-1 fas fa-save"></i>
    {{ 'AbpUi::Save' | abpLocalization }}
  </button>
</form>
